import * as urlUtils from 'utils/url';
import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/reports`,
  PUBLIC_SURVEY_REPORT: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/reports/report_public`,
  PDF: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/download_pdf`,
  FEEDBACK_REPORT: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/feedback_report`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class CustomSurveyReportApi {
  /**
   * Gets all custom survey report.
   * If the parameters from and to are provided then the reports are filtered according to the timestamp.
   *
   * @param {int} customSurveyId
   * @param {int} from Unix timestamp
   * @param {int} to Unix timestamp
   */
  static getAll(customSurveyId, from, to) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, customSurveyId);

    return AuthenticatedRequestService.get(
      urlUtils.addQueryParameters(INDEX_URL, { from, to })
    );
  }

  /**
   * Gets public report for custom survey.
   *
   * @param {int} customSurveyId
   */
  static publicGetReport(customSurveyId) {
    const REPORT_URL = insertIdToUrl(URLS.PUBLIC_SURVEY_REPORT, customSurveyId);
    return AuthenticatedRequestService.get(REPORT_URL);
  }

  /**
   * Gets pdf for custom survey.
   *
   * @param {int} customSurveyId
   */
  static getPdf(customSurveyId) {
    const PDF_URL = insertIdToUrl(URLS.PDF, customSurveyId);
    return AuthenticatedRequestService.get(PDF_URL);
  }

  /**
   * Gets pdf for custom survey.
   *
   * @param {int} customSurveyId
   */
  static getFeedbackReports(customSurveyId, from, to) {
    const INDEX_URL = insertIdToUrl(URLS.FEEDBACK_REPORT, customSurveyId);
    const filters = from && to ? { from, to } : {};
    return AuthenticatedRequestService.get(
      urlUtils.addQueryParameters(INDEX_URL, filters)
    );
  }
}
export default CustomSurveyReportApi;



// WEBPACK FOOTER //
// ./src/apis/reports/CustomSurveyReport.js